import { AI_LOGISTICS_SUGGESTIONS } from '@highlight-cp/constants';

import type { SuggestionItem } from '../../ai-chat-types';

const LOGISTICS_HIGHLIGHT_MANAGED = 'highlight_managed';

const LOGISTICS_LABEL_TO_TYPES: Record<string, string[]> = {
  [AI_LOGISTICS_SUGGESTIONS.choices[0].label]: [LOGISTICS_HIGHLIGHT_MANAGED],
  [AI_LOGISTICS_SUGGESTIONS.choices[1].label]: ['customer_managed'],
  [AI_LOGISTICS_SUGGESTIONS.choices[2].label]: ['onsite_pickup'],
};

export type LogisticsSelectionChoiceInfo = {
  choice: SuggestionItem;
  logisticsTypes: string[];
};

// Resolves logistics types from a suggestion choice using known labels first, then by parsing prompt text.
export const getLogisticsTypesFromChoice = (choice: SuggestionItem): string[] => {
  const mappedTypes = LOGISTICS_LABEL_TO_TYPES[choice.label];
  if (mappedTypes) {
    return mappedTypes;
  }

  const match = choice.prompt.match(/logistic[s]?Type\s*to\s*\[([^\]]+)\]/i);
  if (!match?.[1]) {
    return [];
  }

  return match[1]
    .split(',')
    .map((value) => value.replace(/['"`\s]/g, ''))
    .filter(Boolean);
};

// Determines whether suggestions should be treated as logistics multi-select behavior.
export const isLogisticsSelectionGroup = (
  selectionGroup: string | undefined,
  choiceInfos: LogisticsSelectionChoiceInfo[],
): boolean => {
  return (
    selectionGroup === 'logistics' ||
    choiceInfos.some(({ logisticsTypes }) => logisticsTypes.length > 0)
  );
};

export const applyLogisticsSelectionRules = (
  currentLabels: string[],
  clickedLabel: string,
  logisticsTypesByLabel: Map<string, LogisticsSelectionChoiceInfo>,
): string[] => {
  const labelsWithoutCurrent = currentLabels.filter((label) => label !== clickedLabel);
  const clickedTypes = logisticsTypesByLabel.get(clickedLabel)?.logisticsTypes ?? [];

  if (clickedTypes.includes(LOGISTICS_HIGHLIGHT_MANAGED)) {
    return [clickedLabel];
  }

  const labelsWithoutHighlight = labelsWithoutCurrent.filter((label) => {
    const logisticsTypes = logisticsTypesByLabel.get(label)?.logisticsTypes ?? [];
    return !logisticsTypes.includes(LOGISTICS_HIGHLIGHT_MANAGED);
  });

  return [...labelsWithoutHighlight, clickedLabel];
};
